import React from 'react';

import {
  AppBar,
  Container,
  Stack,
  styled,
  Toolbar,
  Typography
} from '@mui/material';
import facebookSvg from 'assets/images/facebook.svg';
import linkedInSvg from 'assets/images/linked_in.svg';
import logoImgSvg from 'assets/images/logo_img.svg';
import twitterSvg from 'assets/images/twitter.svg';
import {
  ExternalLink,
  ContactUsModal
} from 'modules';



const RootAppBar = styled(AppBar)(({ theme }) => ({
  top: 'auto',
  bottom: 0,
  backgroundColor: 'white'
}));

const StyledTypography = styled(Typography)({
  color: '#486C82',
  fontSize: 14,
  fontWeight: 500
});



export interface IProps { }

export const FC: React.FC<IProps> = props => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      {isOpen && (
        <ContactUsModal.FC onClose={() => setIsOpen(false)} />
      )}

      <RootAppBar
        elevation={0}
        position="fixed"
        color="transparent">
        <Container>
          <Toolbar disableGutters style={{ justifyContent: 'space-around' }}>
            <Stack direction="row" spacing={2} alignItems='center'>
              <img alt='logo' src={logoImgSvg} />
              <StyledTypography>Ridge © 2022</StyledTypography>
            </Stack>

            <Stack direction="row" spacing={3}>
              <ExternalLink.Text
                onClick={() => setIsOpen(true)}>
                <StyledTypography>Contact Us</StyledTypography>
              </ExternalLink.Text>

              <ExternalLink.Text href="">
                <StyledTypography>License</StyledTypography>
              </ExternalLink.Text>

              <ExternalLink.Text href='https://app.termly.io/document/terms-of-use-for-saas/a3dcd7e8-0fda-49db-9713-d1040682156e'>
                <StyledTypography>Terms of Use</StyledTypography>
              </ExternalLink.Text>

              <ExternalLink.Text href='https://app.termly.io/document/privacy-policy/20c91064-8761-4206-8929-13b1454f8d8b'>
                <StyledTypography>Privacy Policy</StyledTypography>
              </ExternalLink.Text>
            </Stack>

            <Stack direction="row" spacing={3}>
              <img alt='twitter' src={twitterSvg} />
              <img alt='facebook' src={facebookSvg} />
              <img alt='linkedIn' src={linkedInSvg} />
            </Stack>
          </Toolbar>
        </Container>
      </RootAppBar>
    </>
  );
};
